import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import HeaderComponent from './shared/components/header/header.component';
import { SpinnerContainerComponent } from './shared/components/spinner-container/spinner-container.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { WhatsappButtonComponent } from './shared/components/whatsapp-button/whatsapp-button.component';


@Component({
    selector: 'app-root',
    imports: [RouterModule, HeaderComponent, SpinnerContainerComponent, FooterComponent, WhatsappButtonComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: true
})
export class AppComponent { }
